

import eplContent from './eplContent';
import laLigaContent from './laLigaContent';
import uclContent from './uclContent';
import serieAContent from './serieAContent';
import bundesligaContent from './bundesligaContent';
import ligue1Content from './ligue1Content';
import brasileiraoContent from './brasileiraoContent';
import argentinaContent from './argentinaContent';

export const leagueContent = {
  39: eplContent,
  140: laLigaContent,
  2: uclContent,
  135: serieAContent,
  78: bundesligaContent,
  61: ligue1Content,
  71: brasileiraoContent,
  128: argentinaContent,
};